import { CreateFormTemplateFieldRequest } from 'mapistry-shared';
import { useCallback } from 'react';
import {
  CreateFormTemplateFieldGroupFormValues,
  EditableFormTemplateFieldGroup,
  FieldGroupSlug,
} from '../../types';
import { getFieldCopies } from './newFieldHelpers';

const GENERIC_ERROR_MESSAGE = 'Something went wrong when copying the group.';

export const useCopyGroup = ({
  activeGroupSlug,
  addGroup,
  groups,
}: {
  activeGroupSlug: FieldGroupSlug | undefined;
  addGroup: (
    group: CreateFormTemplateFieldGroupFormValues,
    groupFields: CreateFormTemplateFieldRequest[],
    insertAtIndex?: number,
  ) => void;
  groups: EditableFormTemplateFieldGroup[];
}) => {
  const copyGroup = useCallback(
    (createGroupFormValues: CreateFormTemplateFieldGroupFormValues): void => {
      const originalGroupIdx = groups.findIndex(
        (group) => group.slug === activeGroupSlug,
      );
      const originalGroup = groups[originalGroupIdx];

      if (originalGroupIdx === -1 || !originalGroup)
        throw new Error(GENERIC_ERROR_MESSAGE);

      const { fieldCopies } = getFieldCopies({
        fields: originalGroup.fields,
        fieldValuesMapper: (field) => {
          const newField = { ...field, attributes: [] };
          if (!createGroupFormValues.isDuplicable) {
            newField.isDuplicableDisplayField = false;
          }
          return newField;
        },
        errorMessage: GENERIC_ERROR_MESSAGE,
      });

      addGroup(createGroupFormValues, fieldCopies, originalGroupIdx + 1);
    },
    [activeGroupSlug, addGroup, groups],
  );

  return copyGroup;
};
